export default __webpack_public_path__ + "static/media/mini-4.27b5dd69.jpg";